import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

export default function Contact() {
  return (
    <>
      <Navbar/>

<div className="bg-[#F9F6F0] min-h-screen pt-32 pb-24 px-6 md:px-12 lg:px-20 relative">
      
      {/* Luxury Minimalist Marathi Pattern Motif Background Accent */}
      <div className="absolute top-12 right-0 w-80 h-80 opacity-5 pointer-events-none select-none">
        <svg viewBox="0 0 100 100" className="w-full h-full fill-current text-[#5c1d24]">
          <path d="M50,0 L100,35 L80,90 L20,90 L0,35 Z M50,15 L85,40 L70,80 L30,80 L15,40 Z" />
          <circle cx="50" cy="50" r="8" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto space-y-16">
        
        {/* Header Section */}
        <div className="text-center max-w-2xl mx-auto space-y-4">
          <span className="text-[10px] font-semibold uppercase tracking-widest text-[#5c1d24] bg-[#5c1d24]/5 px-4 py-1.5 rounded-full">
            संपर्क • Connect
          </span>
          <h1 className="font-serif text-4xl md:text-5xl text-neutral-900 tracking-wide font-light">
            Atelier Communication
          </h1>
          <div className="w-12 h-[1px] bg-amber-700/60 mx-auto mt-4"></div>
          <p className="text-xs text-neutral-500 font-light leading-relaxed max-w-md mx-auto pt-1">
            Whether arranging a private bridal consultation or looking to explore our heritage textiles, we welcome your arrival.
          </p>
        </div>

        {/* Main Split Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          
          {/* Left Block: Information Panel (5 Columns) */}
          <div className="lg:col-span-5 flex flex-col justify-between bg-white border border-neutral-200/60 p-8 md:p-10 rounded-sm shadow-xs relative">
            {/* Dynamic Subtle Top Accent Line */}
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-[#5c1d24]"></div>

            <div className="space-y-8">
              {/* Location Address Area */}
              <div className="space-y-3">
                <span className="text-[10px] font-bold uppercase tracking-widest text-amber-700 block">
                  स्थान • Location
                </span>
                <h3 className="font-serif text-xl text-neutral-900 font-medium tracking-wide">
                  Flagship Studio
                </h3>
                <div className="font-serif text-sm text-neutral-600 space-y-0.5 tracking-wide leading-relaxed pl-3 border-l border-neutral-200">
                  <p className="font-sans font-semibold text-neutral-900 text-xs">Tuljai Nauvari Boutique</p>
                  <p>Shraddha Colony, Near Shrikhande Hardware ,</p>
                  <p>Arjun Nagar, Amravati Maharashtra 444603</p>
                </div>
              </div>

              {/* Operational Timings */}
              <div className="space-y-3 pt-6 border-t border-neutral-100">
                <span className="text-[10px] font-bold uppercase tracking-widest text-amber-700 block">
                  वेळ • Hours
                </span>
                <div className="font-serif text-sm text-neutral-600 space-y-1 tracking-wide pl-3 border-l border-neutral-200">
                  <p className="font-sans text-xs text-neutral-400">Monday — Sunday</p>
                  <p className="text-[#5c1d24] font-medium text-md">11:00 AM – 8:30 PM</p>
                  {/* <p className="text-[11px] text-amber-800 italic font-sans pt-1">Mondays are strictly by prior bridal appointment</p> */}
                </div>
              </div>
            </div>

            {/* Premium Logo Links Section */}
            <div className="space-y-3 pt-8 border-t border-neutral-100">
              <span className="text-[10px] font-bold uppercase tracking-widest text-amber-700 block">
                डिजिटल कनेक्ट • Digital Ecosystem
              </span>
              
              <div className="grid grid-cols-3 gap-3 pt-1">
                {/* Google Business Connect */}
                <a 
                  href="https://share.google/XqEr5NM7Wi8CwzCgW" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex flex-col items-center justify-center p-4 border border-neutral-100 rounded-sm hover:border-[#5c1d24] hover:shadow-sm transition-all duration-300 group"
                  title="Google Business Profile"
                >
                  <svg className="w-5 h-5 text-neutral-400 group-hover:text-amber-600 transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12.24 10.285V13.4h6.887c-.275 1.565-1.88 4.604-6.887 4.604-4.33 0-7.866-3.577-7.866-8s3.536-8 7.866-8c2.46 0 4.105 1.025 5.047 1.926l2.427-2.334C17.955 2.192 15.34 1 12.24 1 5.92 1 1 5.92 1 12s4.92 11 11.24 11c6.6 0 11-4.65 11-11.2 0-.75-.075-1.335-.165-1.515H12.24z"/>
                  </svg>
                  <span className="text-[9px] font-medium tracking-wider text-neutral-400 group-hover:text-neutral-800 transition-colors duration-300 mt-2 uppercase">Google</span>
                </a>

                {/* Instagram Connect */}
                <a 
                  href="https://www.instagram.com/tuljai_nauvari_boutique?igsh=M2p1aGk1ZHVxZnJv" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex flex-col items-center justify-center p-4 border border-neutral-100 rounded-sm hover:border-[#5c1d24] hover:shadow-sm transition-all duration-300 group"
                  title="Follow on Instagram"
                >
                  <svg className="w-5 h-5 text-neutral-400 group-hover:text-[#5c1d24] transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                  </svg>
                  <span className="text-[9px] font-medium tracking-wider text-neutral-400 group-hover:text-neutral-800 transition-colors duration-300 mt-2 uppercase">Instagram</span>
                </a>

                {/* Facebook Connect */}
                <a 
                  href="https://www.facebook.com/share/1cPXuHr9bN/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex flex-col items-center justify-center p-4 border border-neutral-100 rounded-sm hover:border-[#5c1d24] hover:shadow-sm transition-all duration-300 group"
                  title="Connect on Facebook"
                >
                  <svg className="w-5 h-5 text-neutral-400 group-hover:text-blue-700 transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
                  </svg>
                  <span className="text-[9px] font-medium tracking-wider text-neutral-400 group-hover:text-neutral-800 transition-colors duration-300 mt-2 uppercase">Facebook</span>
                </a>
              </div>
            </div>

          </div>

          {/* Right Block: Minimalist Interactive Map Map Interface (7 Columns) */}
          <div className="lg:col-span-7 relative min-h-[440px] bg-neutral-100 border border-neutral-200/60 rounded-sm shadow-sm overflow-hidden group">
            <iframe 
              title="Tuljai Flagship Boutique Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3725.671841621976!2d77.771734374754!3d20.9656895899428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd6a3235187c491%3A0xb48c7874d5ec1738!2sTuljai%20Nauvari%20Boutique!5e0!3m2!1sen!2sin!4v1783493818255!5m2!1sen!2sin" 

              className="absolute inset-0 w-full h-full border-0 grayscale hover:grayscale-0 contrast-105 transition-all duration-750 ease-in-out"
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>

            {/* Floating Luxury Map Badge */}
            <div className="absolute top-4 right-4 bg-[#5c1d24] text-amber-300 text-[9px] font-semibold tracking-widest uppercase py-2 px-4 border border-amber-400/20 shadow-md pointer-events-none rounded-sm">
              📍 Flagship Boutique
            </div>

            {/* Launch App Overlay Link */}
            <div className="absolute bottom-4 right-4 z-10">
              <a 
                href="https://maps.google.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-white text-neutral-900 border border-neutral-200 shadow-sm px-4 py-2 text-[10px] font-bold uppercase tracking-widest inline-flex items-center space-x-2 hover:bg-[#5c1d24] hover:text-white hover:border-[#5c1d24] transition-all duration-300 rounded-sm"
              >
                <span>Direct Navigation</span>
                <span className="text-xs">➔</span>
              </a>
            </div>
          </div>

        </div>

      </div>
    </div>

      <Footer/>
    </>
  )
}
